import { useQuery } from '@apollo/client';
import { GET_CASE_CLASSIFICATION } from 'modules/Apollo/queries';
import { useBaseViewerData } from '../../../StudyLoader/useStudies';
import type { StudyClassificationSummary } from 'generated/graphql';
import { WithApolloContext } from 'modules/Apollo/types';

export const useGetCaseClassification = ({
  context,
}: WithApolloContext): {
  classification?: StudyClassificationSummary[];
  loadingClassification: boolean;
} => {
  const { smids: studySmids } = useBaseViewerData({ context });
  const { data, loading: loadingClassification } = useQuery(GET_CASE_CLASSIFICATION, {
    variables: { studySmids },
    context,
  });
  return { classification: data?.caseClassification, loadingClassification };
};
